<template>
  <PageHeader image="header-7" withMobile :title="$lang('title')" :breadcrumbs="$lang('breadcr')" />
  <!-- section -->
  <section class="pt-8 pb-9 bg-blue4">
    <div class="container">
      <div class="row mb-5">
        <div class="col-lg-12">
          <h2 class="fw-semibold text-blue2 mb-4">{{ $lang("section.title") }}</h2>
          <h3 class="fw-semibold text-green1 mb-4">{{ $lang("section.subtitle") }}</h3>
          <ol class="ml-4 d-flex flex-column gap-4">
            <!-- Portuguese still has 17 clauses, so skip numbers a locale doesn't define -->
            <template v-for="n in 20" :key="n">
              <li v-if="$lang(`section.list${n}`)" v-html="$lang(`section.list${n}`)"></li>
            </template>
          </ol>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <Accordion class="accordion-long" :data="$lang('items')" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PageHeader from "@/components/PageHeader";
import Accordion from "@/components/Accordion.vue";

export default {
  components: {
    PageHeader,
    Accordion,
  },
};
</script>

<style>
/* the Entry Visa section is taller than the shared 2000px open height */
.accordion.accordion-long li.active .accordion-body {
  max-height: none;
}
</style>
